import React from 'react';
import { Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import EstimatesTable from './EstimatesTable';
import {
  ScreenContainer,
} from '../../CommonComponents';
import { getAllSites } from '../../redux/actions/sites';
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import {
  getEstimates,
} from '../../redux/actions/common';

const Estimates = ({ fetchEstimates }) => (
  <ScreenContainer title="Estimates">
    <PrimaryFilters
      fetchFunction={fetchEstimates}
      selectedValue={() => {}}
      visibleProduct
      location="estimates"
    />
    <div className="row">
      <Divider />
      <div className="col-12">
        <br />
        <EstimatesTable />
        <br />
      </div>
    </div>
  </ScreenContainer>
);

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  fetchEstimates: getEstimates,
};

export default connect(mapState, mapActions)(Estimates);
